import { Component, OnInit, ViewChild } from '@angular/core';
import { AccessService } from '../service/access.service';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-access-employee-list',
  templateUrl: './access-employee-list.component.html',
  styleUrls: ['./access-employee-list.component.css'],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'es'},
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
  ],
})
export class AccessEmployeeListComponent implements OnInit {
  @ViewChild('paginator') paginator: MatPaginator;
  //paginator
  pageSizeOptions: any [] = [5, 10, 20];
  pageSize = 10;
  pageNumber = 1;
  totalPage: any [] = [];
  totalItems: number;
  SeeItems: any[] = [];
  statusOptions: any;
  types: any=[];
  isActiveF: any="";
  busqueda: any="";



  //-----------Filters
  requestF: string;
  typeF: string;
  statusF: string;
  requestDateF: string;
  //---------URL MAKE
  order: string;
  baseReq: string;
  //-----------------Asc&Desc state-------
  requestDesc = false;
  typeDesc = false;
  statusDesc = false;
  requestDateDesc = false;
  requestorDesc=false;
  requesterId= false;
  //---------------datepicker
  maxDate: Date;
  dateSelectStart: Date;
  dateSelectEnd: Date;
  sinfecha: Date;

  constructor(private dataApi: AccessService,
              private spinner: NgxSpinnerService,
              private _snackBar: MatSnackBar,
              private datePipe: DatePipe,
              public dialog: MatDialog) {

    this.maxDate = new Date();
    this.requestF = '';
    this.typeF = '';
    this.statusF = '';
    this.requestDateF = '';
    this.order = "&order_by=requestNumber&desc=true";
    this.baseReq= this.order;

  }

  getListEmployeeAccess()
  {
    this.spinner.show("loading")
    this.dataApi.getListEmployeeAccess(this.pageNumber, this.pageSize, false, this.baseReq, true, false).subscribe((data: any) => {
      if(data.items===null || data.items===undefined){
        this.SeeItems= [];
      } else {
        this.SeeItems = data.items;
        this.pageNumber = data.paginator.page;
        this.pageSize = data.paginator.limit;
        this.totalPage = data.paginator.totalPages;
        this.totalItems = data.paginator.totalItems;
      }
      this.statusOptions = data.statuses;
      this.types= data.types;

      this.spinner.hide("loading")},
                                                                                                            (err) => {
                                                                                                              this.spinner.hide("loading");
                                                                                                              if(err.error.error !== 'Invalid token.') {
                                                                                                                this.dialog.open(ModErrorComponent, {
                                                                                                                  width: 'auto',
                                                                                                                  panelClass: 'myapp-no-padding-dialog',
  
                                                                                                                });
                                                                                                              }
                                                                                                            });
  }

  ngOnInit() {
    this.getListEmployeeAccess();

  }
  handlePage(e: PageEvent) {
    this.pageSize = e.pageSize;
    this.pageNumber = e.pageIndex + 1;
    this.getListEmployeeAccess();
  }
  //------ method set filters ---
  orderby(nameColumn, typeAsc){
    switch(nameColumn){
      case 'requestNumber': {
        this.requestDesc = !this.requestDesc;
        this.statusDesc = false;
        this.requestDateDesc = false;
        this.requestorDesc= false;
        this.typeDesc=false;
        break;
      }
      case 'type':{
        this.typeDesc = !this.typeDesc;
        this.requestorDesc= false;
        this.requestDesc = false;
        this.statusDesc = false;
        this.requestDateDesc = false;
        break;
      }
      case 'requesterId': {
        this.requestorDesc= !this.requestorDesc;
        this.requestDesc = false;
        this.statusDesc = false;
        this.requestDateDesc = false;
        this.typeDesc=false;
        break;
      }
      case 'status':{
        this.requestDesc = false;
        this.statusDesc = !this.statusDesc;
        this.requestDateDesc = false;
        this.requestorDesc= false;
        this.typeDesc=false;
        break;
      }
      case 'requestDate':{
        this.requestDesc = false;
        this.statusDesc = false;
        this.requestDateDesc = !this.requestDateDesc;
        this.requestorDesc= false;
        this.typeDesc=false;
        break;
      }

    }
    const param = `&order_by=${nameColumn}&desc=${typeAsc}`;
    this.order = param;
    this.getEmployeeListFilter();
  }
  requestFilter(){
    if(this.requestF === '' || this.requestF === null || this.requestF === undefined ){
      return '';
    } else {
      return '&requestNumber='+ this.requestF;
    };
  }
  filterType(){
  }
  TypeFilter(){
    if(this.typeF === '' || this.typeF === null || this.typeF === undefined ){
      return '';
    } else {
      return '&type='+ this.typeF;
    };
  }
  StatusFilter(){
    if(this.statusF === '' || this.statusF === null || this.statusF === undefined){
      return '';
    } else {
      return '&status=' + this.statusF;
    };
  }
  DateRangeFilter()
  {
    let anio = new Date();
    anio.setFullYear(2099,12,31);
    let aniofin = new Date();
    aniofin.setFullYear(2009,12,31);

    if(this.dateSelectEnd===null || this.dateSelectEnd===undefined)
    {

      this.dateSelectEnd = anio;
    }

    if(this.dateSelectStart===null || this.dateSelectStart===undefined)
    {
      this.dateSelectStart = aniofin;
    }

    if(this.dateSelectStart === null || this.dateSelectStart === undefined ||
       this.dateSelectEnd === null || this.dateSelectEnd === undefined){
      return '';
    } else
    {
      return '&startDate=' + this.transformDate(this.dateSelectStart) + '&endDate='+ this.transformDate(this.dateSelectEnd);
    };
  }
  transformDate(date: Date){
    return(this.datePipe.transform(date, 'yyyy-MM-dd'));
  }
  getEmployeeListFilter() {
    if(this.dateSelectStart && this.dateSelectEnd){
      if(this.dateSelectStart>this.dateSelectEnd){
        this._snackBar.open("Invalid Date Filter", '', {
          duration: 3000,
        });
        return;
      }
    }
    this.baseReq=this.order + this.TypeFilter() + this.StatusFilter()+ this.requestFilter() + this.DateRangeFilter();
    this.applyFilter(this.baseReq);
  }
  applyFilter(filterUrl){
    this.spinner.show("loading");
    this.paginator.firstPage();
    this.dataApi.getListEmployeeAccess(  this.pageNumber, this.pageSize, false, filterUrl, true, false
    ).subscribe((data: any) => {
      if(data.items === null || data.items === undefined) {
        this.SeeItems = [];
      } else {
        this.SeeItems = data.items;
        this.pageNumber = data.paginator.page;
        this.pageSize = data.paginator.limit;
        this.totalPage = data.paginator.totalPages;
        this.totalItems = data.paginator.totalItems;
      }
      this.statusOptions = data.statuses;
      this.types = data.types;
      this.spinner.hide("loading");
    }, (err) => {
      this.spinner.hide("loading");
      if(err.error.error !== 'Invalid token.') {
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',
  
        });
      }
   });
  }
    clearFilter(){

      this.maxDate = new Date();
      this.dateSelectStart= null;
      this.dateSelectEnd= null;
      this.requestF = '';
      this.typeF = '';
      this.statusF = '';
      this.requestDateF = '';
      this.order = "&order_by=requestNumber&desc=true";
      this.getEmployeeListFilter();
    }

  getallCardFilter(){

  }

  isNegative(requestF:string){
    let evaluate=Number(requestF)
    if(evaluate<0) {
      return true
    }
    else {
      return false;
    }  

  }
}
